import { useState } from 'react';

export const useTrackEvents = (initial) => {
  const eventNames = [
    { key: 'DRAFT', displayName: 'Draft' },
    { key: 'EXPECTED', displayName: 'Expected' },
    { key: 'IN_TRANSIT', displayName: 'In transit' },
    { key: 'OUT_FOR_DELIVERY', displayName: 'Out for delivery' },
    { key: 'COMPLETED', displayName: 'Completed' },
    { key: 'AWAITING_NEXT_ATTEMPT', displayName: 'Awaiting next attempt' },
    { key: 'RETURNED', displayName: 'Returned' },
  ];
  const [events, setEvents] = useState(
    eventNames.map((n, i) => {
      const existing = initial?.find((e) => e.keyword === n.key);
      return {
        index: i,
        key: n.key,
        name: n.displayName,
        on: existing?.on || false,
        subject: existing?.subject || '',
        body: existing?.body || '',
        closing: existing?.closing || '',
      };
    }),
  );

  const toggleEvent = (index) => {
    setEvents([...events.map((e, i) => (i === index ? { ...e, on: !e.on } : e))]);
  };
  const updateEvent = ({ index, field, value }) =>
    setEvents([...events.map((e, i) => (i === index ? { ...e, [field]: value } : e))]);

  const initialize = (initial) => {
    setEvents(
      eventNames.map((n, i) => {
        const existing = initial?.find((e) => e.keyword === n.key);
        return {
          index: i,
          key: n.key,
          name: n.displayName,
          on: existing?.value === 'true' || false,
          subject: existing?.extraData?.subject || '',
          body: existing?.extraData?.body || '',
          closing: existing?.extraData?.closing || '',
        };
      }),
    );
  };
  return {
    eventNames,
    events,
    toggleEvent,
    updateEvent,
    initialize,
  };
};
